export const HISTORY_EMPTY_DISPLAY_VALUE = '__EMPTY__';

export function hasHistoryDisplayValue<T>(
	value: T
): value is Exclude<T, null | undefined> {
	return value !== null && value !== undefined;
}

export function isExplicitHistoryEmptyValue(
	value: unknown
): value is typeof HISTORY_EMPTY_DISPLAY_VALUE {
	return value === HISTORY_EMPTY_DISPLAY_VALUE;
}
